import { render, staticRenderFns } from "./docReport.vue?vue&type=template&id=31dca463&scoped=true&"
import script from "./docReport.vue?vue&type=script&lang=js&"
export * from "./docReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dca463",
  null
  
)

export default component.exports